
import { SafePipe } from './safePipe';
import { NgModule } from '@angular/core';
import { SafeHtmlPipe } from './safeHtmlPipe';
import { TimeFormat } from './time.format';
import { FilterPipe } from './search.pipe';

@NgModule({
    imports: [],
    declarations: [SafePipe, SafeHtmlPipe, TimeFormat, FilterPipe],
    exports: [SafePipe, SafeHtmlPipe, TimeFormat, FilterPipe]
})

export class PipesModule { }